export default {
  NewTask: 'New task',
  Run: 'Run',
  TaskEditor: {
    Date: 'Date',
    Cancel: 'Cancel',
    SaveTask: 'Save task',
    AddTask: 'Add task',
    TitlePlaceholder: 'Title',
    DescriptionPlaceholder: 'Description',
    NoMatchesFound: 'No matches found.',
  },
  AssigneePicker: {
    Assignee: 'Assignee',
    SearchPlaceholder: 'Search',
    Tabs: {
      Admin: 'Admin',
      Caregivers: 'Caregivers',
      Clients: 'Clients',
    },
    NoAdminUsersFound: 'No admin users found.',
    NoCaregiversFound: 'No caregivers found.',
    NoClientsFound: 'No clients found.',
  },
  DatePickerQuickOptionCalendar: {
    TypeDatePlaceholder: 'Type a date',
    Today: 'Today',
    Tomorrow: 'Tomorrow',
    ThisWeekend: 'This weekend',
    NextWeek: 'Next week',
    Time: 'Time',
  },
  ReminderPicker: {
    Reminders: 'Reminders',
    PredefinedOptions: {
      TabTitle: 'Before Task',
      Options: {
        OneHourBefore: '1 Hour Before',
        TwoHoursBefore: '2 Hours Before',
        ThreeHoursBefore: '3 Hours Before',
        FourHoursBefore: '4 Hours Before',
        SixHoursBefore: '6 Hours Before',
        TwelveHoursBefore: '12 Hours Before',
        OneDayBefore: '1 Day Before',
        TwoDaysBefore: '2 Days Before',
      },
    },
    Custom: {
      TabTitle: 'Date & Time',
      Placeholder: 'Thursday at 3pm',
      Description: 'Set a custom reminder for a time (e.g. 3 PM) or specific day and time (e.g. Friday at 2:25 PM)',
    },
  },
};
